export const EMAIL_CREDENTIALS_EDIT_QUERY_PARAM = 'oauth-open-id';
